/* eslint-disable
no-return-await, no-console, no-param-reassign,
no-trailing-spaces, arrow-body-style
*/
import axios from 'axios';
import moment from 'moment';
import store from '../store';

import helper from '@/_libs/helper';
import order from './_order';

const {
  mapOrderStatus,
  ORDER_STATUS,
  SHIPMENT_STATUS,
  BACK_ORDER_STATUS,
} = order;

// alert(JSON.stringify(store.getters));

// const store = {
//   ...mapGetters({
//     orderNotifications: 'orderNotifications',
//   }),
// };

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const CURRENT_TIME = new Date().getTime();

const COL_TYPE = {
  Date,
  Number,
  Time: 'Time',
  OrderStatus: 'OrderStatus',
  ShipmentStatus: 'ShipmentStatus',
  BackOrderStatus: 'BackOrderStatus',
};

const MOCK = {
  provinces: [
    { id: 'A', name: 'A' },
    { id: 'B', name: 'B' },
  ],
  customers: [
    {
      id: 1,
      name: 'บริษัท เอ จำกัด',
      image: 'http://placekitten.com/128/128',
      province: 'bkk',
      balance: 50000.00,
      grade: 'b',

      address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
      phone: '0897654321',
      unpaid: {
        count: 30,
        total: 56000000.00,
      },
    },
    {
      id: 2,
      name: 'บริษัท บี จำกัด (มหาชน)',
      image: 'http://placekitten.com/128/128',
      province: 'cnx',
      balance: 60000.00,
      grade: 'c',

      address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
      phone: '0812345678',
      unpaid: {
        count: 10,
        total: 2000000.00,
      },
    },
    {
      id: 3,
      name: 'บริษัท ซี จำกัด (มหาชน)',
      image: 'http://placekitten.com/128/128',
      province: 'cnx',
      balance: 60000.00,
      grade: 'a',

      address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
      phone: '0812345678',
      unpaid: {
        count: 10,
        total: 2000000.00,
      },
    },
    {
      id: 4,
      name: 'บริษัท ดี จำกัด (มหาชน)',
      image: 'http://placekitten.com/128/128',
      province: 'cnx',
      balance: 60000.00,
      grade: 'b',

      address: '120/1 ม.1 ต.องครักษ์ อ.องครักษ์ จ.นครนายก 26120',
      phone: '0812345678',
      unpaid: {
        count: 10,
        total: 2000000.00,
      },
    },
  ],
  insight: {
    recent: [
      {
        dueDate: DATE_TODAY,
        productCode: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        amount: 1,
        price: 69000.46,
        total: 69000.46,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 2',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
      {
        dueDate: DATE_TODAY,
        productCode: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        amount: 1,
        price: 69000.46,
        total: 69000.46,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 3',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
      {
        dueDate: DATE_TODAY,
        productCode: '3D6XN5C',
        productName: 'item 4',
        amount: 2,
        price: 69000.46,
        total: 69000.46 * 2,
      },
    ],
    unpaid: [
      {
        dueDate: DATE_TODAY,
        documentCode: 'D6XN5CM3',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: 'D6XN5CH8',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 55555.55,
        overDueDateCount: 1,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: 'TD5IA2',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: '0SR674DM',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 69000.46 * 2,
        overDueDateCount: 2,
      },
      {
        dueDate: DATE_TODAY,
        documentCode: '0SR123',
        customerName: 'บริษัท ลิ้มเจริญค้าวัสดุก่อสร้าง จำกัด',
        total: 55555.55,
        overDueDateCount: 1,
      },
    ],
  },
  history: {
    sell: [
      {
        entryNo: '24/569',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,

        updated: true,
      },
      {
        entryNo: '24/568',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 55555,
        status: ORDER_STATUS.APPROVED,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
      },
      {
        entryNo: '24/609',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 12345,
        status: ORDER_STATUS.APPROVED,
        shipmentStatus: SHIPMENT_STATUS.DELIVERED,

        updated: true,
      },
      {
        entryNo: '24/519',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 76739,
        status: ORDER_STATUS.REJECTED,
        shipmentStatus: SHIPMENT_STATUS.REJECTED,
      },
    ],
    unpaid: [
      {
        id: 0,
        dueDate: DATE_3_DAYS_AGO,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        daysPastDue: 3,
        sellDate: DATE_LASTWEEK,

        updated: true,
      },
      {
        id: 1,
        dueDate: DATE_YESTERDAY,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        daysPastDue: 1,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 2,
        dueDate: DATE_3_DAYS_AGO,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 12453.46,
        daysPastDue: 3,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 3,
        dueDate: DATE_YESTERDAY,
        entryNo: 'AB63111208',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        daysPastDue: 3,
        sellDate: DATE_3_DAYS_AGO,

        updated: true,
      },
      {
        id: 4,
        dueDate: DATE_YESTERDAY,
        entryNo: 'AB63111209',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 9198.46,
        daysPastDue: 1,
        sellDate: DATE_LASTWEEK,

        updated: true,
      },
    ],
    bestSellings: [
      { id: '01', name: 'ไม้อัดพิเศษ', total: 69000.46 },
      { id: '02', name: 'ไม้อัดธรรมดา', total: 69000.46 },
      { id: '03', name: 'ไม้แปรรูป', total: 69000.46 },
      { id: '04', name: 'กระดาษอัด', total: 69000.46 },
      { id: '05', name: 'ประตู', total: 6659.0 },
      { id: '06', name: 'บอร์ดหนา', total: 5512.0 },
      { id: '07', name: 'บอร์ดเคลือบ/ไฟเมก้า', total: 4320.0 },
      { id: '08', name: 'ลวด', total: 3319.0 },
      { id: '09', name: 'ตะปู/ตะขอ', total: 0 },
      { id: '10', name: 'สังกะสี/โลหะแปรรูป', total: 0 },
      { id: '11', name: 'อลูมีเนียม/อุปกรณ์', total: 0 },
      { id: '12', name: 'ซีไลน์/เหล็กขึ้นรูป', total: 0 },
      { id: '13', name: 'เคมี/น้ำยา', total: 0 },
      { id: '99', name: 'เบ็ดเตล็ด', total: 0 },
    ],
    bestSellingsGroupRatio: [
      { group: '01', value: 0.02 },
      { group: '02', value: 0.02 },
      { group: '03', value: 0.06 },
      { group: '04', value: 0.03 },
      { group: '05', value: 0.02 },
      { group: '06', value: 0.03 },
      { group: '07', value: 0.02 },
      { group: '08', value: 0.15 },
      { group: '09', value: 0.15 },
      { group: '10', value: 0.10 },
      { group: '11', value: 0.30 },
      { group: '12', value: 0.05 },
      { group: '13', value: 0.03 },
      { group: '99', value: 0.02 },
    ],
    // outstanding: [],
    backOrder: [
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111205',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.READY,

        updated: true,
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111209',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.READY,

        updated: true,
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111212',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,
      },
      {
        date: DATE_TODAY,
        entryNo: 'AB63111213',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,
      },
      {
        date: DATE_TODAY,
        entryNo: 'AB63111220',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111201',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.CANCELLED,

        updated: true,
      },
    ],
    quotation: [
      {
        entryNo: '24/569',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
      },
      {
        entryNo: '24/568',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 55555,
      },
      {
        entryNo: '24/609',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 12345,
      },
      {
        entryNo: '24/519',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 76739,
      },
    ],

    cs: {
      productPurchase: [
        {
          date: DATE_TODAY,
          productId: 'D6XN5CM',
          productName: 'ไม้อัด ตรากระต่าย',
          productGroupId: '12',
          quantity: 12,
          priceWithComm: 6000.04 * 12,
          total: 72000.48,
        },
        {
          date: DATE_TODAY,
          productId: '3D6XN5C',
          productName: 'ประตูไม้อัด ตรากระต่าย',
          productGroupId: '01',
          quantity: 2,
          priceWithComm: 6000.04 * 2,
          total: 6000.04 * 2,
        },
        {
          date: DATE_TODAY,
          productId: 'H8TD5IA2',
          productName: 'ไม้อัดลายอิตาลี ตรากระต่าย',
          productGroupId: '01',
          quantity: 10,
          priceWithComm: 6000.04 * 10,
          total: 6000.04 * 10,
        },
      ],
    },
  },
};

const mapCustomer = elm => ({
  id: elm.id,
  name: elm.name,
  image: elm.image ? elm.image : 'http://placekitten.com/72/72',
  province: elm.province,
  balance: elm.account ? elm.account.remaining_credit : null,
  grade: elm.account ? elm.account.grade : null,
  address: elm.address,
  phone: elm.telephone ? elm.telephone : '-',
  unpaid: { // next time use .account, I leave this one just in case it is used elsewhere
    count: elm.account ? elm.account.outstanding_bills_75days : null,
    total: elm.account ? elm.account.outstanding_balance : null,
  },
  account: elm.account,
});

const customer = {
  async provincesList() { // TODO:
    return await helper.call('customers.provinces.list', {
      success: true,
      data: MOCK.provinces,
    }, async () => {
      const res = await axios(helper.path('customers/provinces'));
      res.data = res.data.map(elm => ({
        value: elm.province,
        text: elm.province,
      }));
      // res.data.splice(0, 0, { value: '', text: 'เลือกจังหวัด' });
      return res;
    });
  },
  async list(page = 1, filterName, filterProvince) {
    return await helper.call('customers.list', {
      success: true,
      data: MOCK.customers,
    }, async () => {
      console.log('start fetch');
      let res = await axios(helper.path('customers'), {
        params: {
          'page[number]': page,
          name: !filterName ? undefined : filterName,
          province: !filterProvince ? undefined : filterProvince,
        },
      });
      // console.log(res.data);
      res = helper.dataMap(res, elm => mapCustomer(elm));
      // // res.data.data = res.data.data.map();
      // console.log(res);
      return res;
    });
  },
  // async getById(id) {
  //   const searchResult = MOCK.customers.filter((item) => {
  //     return item.id === id;
  //   });
  //   return await helper.call('customers.by-id', {
  //     success: true,
  //     data: (searchResult ? searchResult[0] : {}),
  //   }, async () => await axios(helper.path(`customers/${id}`)));
  // },
  // async insight(id) {
  //   // console.log(id);
  //   // return {
  //   //   status: 200,
  //   //   data: MOCK.insight,
  //   // };
  //   // TODO: switch back to the API
  //   return await helper.call('customers.insight', {
  //     success: true,
  //     data: MOCK.insight,
  //   }, async () => {
  //     // const res = await axios(helper.path(`customers/${id}`));
  //     const res = await this.history.productPurchase(id);
  //     const recent = res.data.data.splice(0, 5);

  //     const { outstanding } = MOCK.insight;

  //     res.data = {
  //       recent,
  //       outstanding,
  //     };
  //     return res;
  //   });
  // },
  async statForCustomerWithId(id) {
    console.warn('customers.stat is deprecated');
    return await helper.call('customers.stat', {
      success: true,
      data: {
        // basic stat
        unpaid: {
          count: 30,
          total: 56000000.00,
        },
        remaining: 15000,
        mostExpensiveCheque: 15000,

        // extended stat
        grade: 'A',
        extendedStat: {
          overLimitPercentage: 5,
          remainingQuota: -10000,

          outstandingBillCount: 1,
          chequeCount: {
            total: 5,
            thisYear: 4,
          },

          customerType: 2562,
          lifetimeSpends: 98000.56,

          advanceChequeAmount: 20000,
        },
      },
    }, async () => {
      const res = await axios(helper.path(`customers/${id}/stat`));
      return res;
    });
  },
  history: {
    async sell(customerId, page = 1, from, to, filterStatus, filterSearch) {
      // console.log(customerId);
      return await helper.call('customers.history.sell', {
        success: true,
        data: MOCK.history.sell,
      }, async () => {
        let res = await axios(helper.path(`/api/customers/${customerId}/orders/recent`), {
          params: {
            from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
            to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
            'page[number]': page,

            status: (filterStatus !== '' && filterStatus !== null) ? filterStatus : undefined,
            query: !filterSearch ? undefined : filterSearch,
          },
        });

        /**
         * filter out back_order & quotation
         *  (NOW HANDLED BY API)
         */
        // if (['back_order', 'quotation'].includes(filterStatus) === false) {
        //   res = helper.dataFilter(res, (elm) => {
        //     return ['back_order', 'quotation'].includes(elm.status) === false;
        //   });
        // }

        // grab existing notifications
        const ALL_NOTIFICATIONS = store.getters.orderNotifications;
        const ORDERS_WITH_NOTIFICATION = Object.keys(ALL_NOTIFICATIONS);

        // map everything
        res = helper.dataMap(res, (elm) => {
          const mappedOrder = {
            ...elm,

            id: elm.id,
            entryNo: elm.unix_id,
            combinedId: `${elm.unix_id}/${elm.id}`,
            date: elm.created_at,
            time: elm.created_at,
            status: mapOrderStatus(elm.status),
            shipmentStatus: (elm.shipments) ? ((elm.shipments.length === 0) ? 0 : 1) : -1, // eslint-disable-line
            products: elm.products,
          };

          // should show the notification dot or not
          if (ORDERS_WITH_NOTIFICATION) {
            const orderId = elm.id.toString();
            console.log(`${ORDERS_WITH_NOTIFICATION} ${orderId}`);
            console.log(ORDERS_WITH_NOTIFICATION.indexOf(orderId));
            mappedOrder.updated = ORDERS_WITH_NOTIFICATION.includes(orderId);
          }
          return mappedOrder;
        });

        return res;
      });
    },
    async bestSellings(customerId, from, to) {
      console.log(customerId);
      return await helper.call('customers.history.bestSellings', {
        success: true,
        data: MOCK.history.bestSellings,
      }, async () => {
        const res = await axios.get(helper.path(`customers/${customerId}/bestSellers`), {
          params: {
            from: moment(from).format('YYYY-MM-DD hh:mm:ss'),
            to: moment(to).format('YYYY-MM-DD hh:mm:ss'),
          },
        });
        res.data.best_sellers = res.data.best_sellers.map(elm => ({
          ...elm,
          productId: elm.product_id,
          productName: elm.product_name,
          total: Number(elm.total),
        }));
        res.data.best_sellers = res.data.best_sellers.sort((a, b) => a.product_id - b.product_id);
        return res;
      });
    },
    async bestSellingsGroupRatio(customerId) {
      console.log(customerId);
      return await helper.call('customers.history.bestSellingsGroupRatio', {
        success: true,
        data: MOCK.history.bestSellingsGroupRatio,
      }, async () => await axios(helper.path('customers/history/best-sellings-group-ratio')));
    },
    // async unpaid(customerId) {
    //   console.log(customerId);
    //   return await helper.call('customers.history.unpaid', {
    //     success: true,
    //     data: MOCK.history.unpaid,
    //   // }, async () => await axios(helper.path('customers/history/unpaid')));
    //   }, async () => {
    //     const res = await axios(helper.path('billing/outstandings'));

    //     const TODAY = moment(new Date()).startOf('day');
    //     res.data.data = res.data.data.map(elm => ({
    //       ...elm,
    //       sellDate: elm.created_at,
    //       dueDate: elm.due,
    //       daysPastDue: TODAY.diff(moment(elm.due)),
    //       combinedId: `${elm.unix_order_id}/${elm.id}`,
    //     }));
    //     return res;
    //   });
    // },
    async backOrder(customerId, page = 1, from, to, filterSearch) {
      console.log(customerId);
      return await helper.call('customers.history.backOrder', {
        success: true,
        data: MOCK.history.backOrder,
      }, async () => {
        const res = await this.sell(customerId, page, from, to, 'back_order', filterSearch);
        // res.data.data = res.data.data.filter((elm) => {
        //   // && elm.customer_id === id;
        // });
        console.log(res);

        const BACK_ORDERS = [];
        const { data } = res.data;
        for (let i = 0; i < data.length; i += 1) {
          const DAT = data[i];
          for (let j = 0; j < DAT.products.length; j += 1) {
            const PROD = DAT.products[j];

            BACK_ORDERS.push({
              ...DAT,

              date: DAT.updated_at,
              entryNo: DAT.unix_id,
              combinedId: `${DAT.unix_id}/${DAT.id}`,
              status: mapOrderStatus(DAT.status),

              total: Number(PROD.price),
              productId: PROD.product.id,
              productName: PROD.product.name,
              productPrice: Number(PROD.price / PROD.amount),
              amount: PROD.amount,

              products: undefined, // unused in back orders
              product: PROD,
            });
          }
        }

        res.data.data = BACK_ORDERS;
        return res;
      });
    },

    async checkinByLatLng(custId, lat, lng) {
      return await helper.call('customers.history.checkinByLatLng', {
      }, async () => await axios.post(helper.path(`customers/${custId}/checkins`), {
        latitude: lat,
        longitude: lng,
      }));
    },
    async checkinByImg(custId, formData) {
      return await helper.call('customers.history.checkinByImg', {
      }, async () => await axios.post(helper.path(`customers/${custId}/checkins`),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }));
    },
    async getCheckins(custId, date = {}) {
      if (Object.keys(date).length === 0) {
        return await helper.call('customers.history.checkins', {
          success: true,
        }, async () => await axios(helper.path(`customers/${custId}/checkins`)));
      }
      return await helper.call('customers.history.checkins', {
        success: true,
      }, async () => await axios(helper.path(`customers/${custId}/checkins?from=${moment(date.from).format('YYYY-MM-DD hh:mm:ss')}&to=${moment(date.to).format('YYYY-MM-DD hh:mm:ss')}`))); // eslint-disable
    },

    //
    // CS
    //
    async productPurchase(customerId, page = 1, from, to, filterSearch) {
      // console.log(customerId);
      return await helper.call(
        'customerHistory.productPurchase',
        {
          success: true,
          data: [],
        },
        async () => {
          const res = await axios(helper.path(`customers/${customerId}/products/recent`), {
            params: {
              from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
              to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
              'page[number]': page,

              query: !filterSearch ? undefined : filterSearch,
            },
          });

          // PRE-PROCESS
          const mappedPurchases = {};
          const PRODUCT_PURCHASES = [];

          res.data.data.forEach((purchase) => {
            console.log(purchase);
            if (!mappedPurchases[purchase.product_id]) {
              mappedPurchases[purchase.product_id] = {
                ...purchase,
                product: purchase.product,
                productName: purchase.product ? purchase.product.name : '-',
                productId: purchase.product_id.toString(),
                productGroupId: purchase.product ? purchase.product.group_id : '-',

                price: purchase.price,
                amount: 0,
                total: 0,
              };
            }
            const PROD = mappedPurchases[purchase.product_id];

            if (!PROD.purchases) {
              PROD.purchases = [];
            }
            const purchaseEntry = {
              ...purchase,
              productName: purchase.product ? purchase.product.name : '-',
              productId: purchase.product_id.toString(),
              productGroupId: purchase.product ? purchase.product.group_id : '-',

              total: purchase.price,
              amount: purchase.amount,
              price: purchase.price / purchase.amount,

              date: purchase.created_at,
            };
            PROD.amount += Number(purchase.amount);
            PROD.total += Number(purchase.price);
            PROD.purchases.push(purchaseEntry);
          });

          Object.keys(mappedPurchases).forEach((key) => {
            PRODUCT_PURCHASES.push(mappedPurchases[key]);
          });

          // res.data.data = res.data.data.map(elm => ({
          //   ...elm,
          //   productName: elm.product.name,
          //   productId: elm.product.id.toString(),
          //   productGroupId: elm.product.group_id,
          // }));
          res.data.data = PRODUCT_PURCHASES;
          return res;
        },
      );
    },
  },

  COL_TYPE,
  ORDER_STATUS,
  SHIPMENT_STATUS,
  BACK_ORDER_STATUS,

  mapCustomer,
};

export default customer;
